import React, { useContext } from 'react';
import { ComponentContext } from '../../context/componentContext';

const DocumentModal = () => {
  const { docModal, handleDocModal } = useContext(ComponentContext);

  return (
    <div className={docModal ? 'show' : 'hidden'}>
      <div className="absolute right-0 modal-bg z-50">
        <div className="flex flex-wrap h-screen w-screen">
          <div className="relative w-90 h-80 py-10  bg-white rounded px-4 shadow">
            <div className="my-6">
              <h4 className="font-bold text-xl">Sort by</h4>
            </div>

            <button
              className="absolute right-0 top-0 pr-6 pt-6 text-green-600 focus:outline-none"
              onClick={handleDocModal}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-x"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>

            <div className="flex items-center justify-between">
              <label className="mr-3" htmlFor="contracts">
                Contacts
              </label>
              <input id="contracts" type="radio" name="sort" />
            </div>
            <div className="flex items-center justify-between">
              <label className="mr-3" htmlFor="invoices">
                Invoices
              </label>
              <input id="invoices" type="radio" name="sort" />
            </div>
            <div className="flex items-center justify-between">
              <label className="mr-3" htmlFor="receipts">
                Receipts
              </label>
              <input id="receipts" type="radio" name="sort" />
            </div>

            <div className="border-b-2 border-green-600 pt-8"></div>

            <div className="flex flex-wrap justify-between mt-4">
              <button>Clean Search</button>
              <button className="bg-green-600 text-white rounded px-3 py-2">Show Results</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentModal;
